import { daysOfTheWeekP, generalHelpers, millisecondsOneDay, months } from '@monorepo/helpers';
import { Dispatch, FC, SetStateAction, useState } from 'react';
import { Hr } from 'src/components/_commons';
import { NotificationsAssignments } from './commons/NotificationsAssignments';
import { NotificationsSettings } from './commons/NotificationsSettings';
import { NotificationsTitle } from './commons/NotificationsTitle';
import { typeCartsDoc, typeCartPeriod, typeNotificationsDoc, typeNotificationSetting, typeUser } from '@monorepo/models';

type propsType = {
    cartsDoc: typeCartsDoc;
    notificationsDoc: typeNotificationsDoc;
    setRefreshCounter: Dispatch<SetStateAction<number>>;
    users: typeUser[];
};

export const NotificationsCarts: FC<propsType> = ({
    cartsDoc, notificationsDoc, setRefreshCounter, users
}) => {
    const [head1Id, setHead1Id] = useState<number | null | undefined>(notificationsDoc.cartHeadOfDepartmentId);
    const [newNotificationSettings, setNewNotificationSettings] = useState<typeNotificationSetting[]>(notificationsDoc.carts);
    const type = 'carts';

    return (
        <div>
            <NotificationsTitle
                type={type}
            />
            <NotificationsSettings
                head1Id={head1Id}
                head1OriginalId={notificationsDoc.cartHeadOfDepartmentId}
                head2Id={null}
                head2OriginalId={null}
                notificationsDoc={notificationsDoc}
                notificationSettings={notificationsDoc.carts}
                newNotificationSettings={newNotificationSettings}
                setNewNotificationSettings={setNewNotificationSettings}
                setRefreshCounter={setRefreshCounter}
                type={type}
                updateHead1Id={setHead1Id}
                updateHead2Id={() => {}}
                users={users}
            />
            <Hr classes={'my-5'} />
            <Assignments
                cartsDoc={cartsDoc}
            />
        </div>
    );
}

const Assignments = ({ cartsDoc }: { cartsDoc: typeCartsDoc; }) => {
    const cartAssignments = cartsDoc.assignments
        ?.filter(a => !cartsDoc.points?.find(p => p.id === a.pointId)?.wasDeleted)
        .filter(a => new Date(a.year, a.month).getTime() >= new Date(new Date().getFullYear(), new Date().getMonth()).getTime() - millisecondsOneDay)
        .sort((a1, a2) => (a1.name ?? '').localeCompare(a2.name ?? '') || new Date(a1.year, a1.month).getTime() - new Date(a2.year, a2.month).getTime() || a1.weekday - a2.weekday || (a1.startHour ?? 0) - (a2.startHour ?? 0))
        ?? []
    ;

    return (
        <NotificationsAssignments
            content={
                <div className={'my-3'}>
                    {!!cartAssignments.length ?
                        cartAssignments.map((a, i) =>
                            <li key={i} className={'mt-2'}>
                                <span className={'fw-bold'}>{a.participants[0].name} {a.participants[0].lastName}</span>
                                &nbsp;<span className={a.participants[0].phoneNumber ? 'bg-success text-white' : 'bg-general-red text-white'}>(Número {a.participants[0].phoneNumber || 'no cargado'})</span>
                                &nbsp;y <span className={'fw-bold'}>{a.participants[1].name} {a.participants[1].lastName}</span>
                                &nbsp;<span className={a.participants[1].phoneNumber ? 'bg-success text-white' : 'bg-general-red text-white'}>(Número {a.participants[1].phoneNumber || 'no cargado'})</span>
                                &nbsp;en <span className={'fw-bold'}>{a.name}</span>
                                &nbsp;los {daysOfTheWeekP[a.weekday]}
                                &nbsp;de {months[a.month]}/{a.year}
                                &nbsp;a las {generalHelpers.GetTimeFromPeriodObject(a as typeCartPeriod)} hs.
                            </li>
                        )
                        :
                        <>No hay ninguna asignación</>
                    }
                </div>
            }
        />
    );
}
